/*
 * @Author: your name
 * @Date: 2020-09-10 10:18:30
 * @LastEditTime: 2022-06-22 16:26:35
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\pages\index\src\store\modules\user\mutation.js
 */
/*
 * @Author: your name
 * @Date: 2020-07-02 14:21:55
 * @LastEditTime: 2020-08-25 11:38:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\pages\index\src\store\modules\user\mutation.js
 */
import {setUser} from 'fe-coms/components/business/paas/store/local-catch/user'
import Vue from '@/app'

const mutation = {
  // 设置用户信息
  SET_USERINFO: (state, userInfo) => {
    // state.userInfo = userInfo
    for (const key in userInfo) {
      if (!state.userInfo[key]) {
        Vue.set(state.userInfo, key, userInfo[key])
      }
    }
    console.log('3333', userInfo)
    setUser(userInfo)
    if (userInfo.name || userInfo.loginName) {
      state.isAuth = true
    }
  },
  SET_NONDIRTYPE: (state, nonDirType) => {
    state.nonDirType = nonDirType
  },
  SET_NONDIRLINK: (state, nonDirLink) => {
    state.nonDirLink = nonDirLink
  },
  // 是否职能部门
  SET_ISFUNCTIONDEPARTMENT: (state, isFunctionDepartment) => {
    state.isFunctionDepartment = isFunctionDepartment
  },
  // banner上方菜单
  SET_CHANNELMENU: (state, channelMenu) => {
    state.channelMenu = channelMenu
  },
  // 商城首页频道页展示位置
  SET_CHANNELMENU_SHOW: (state, channelMenuShowType) => {
    state.channelMenuShowType = channelMenuShowType
  },
  // 商城底部
  SET_BOTTOMCONTENT: (state, bottomContent) => {
    state.bottomContent = bottomContent
  },
  // 商城头部导航
  SET_HEADERTOPCONTENT: (state, topContent) => {
    state.headerTopContent = topContent
  },
  // 搜索框位置
  SET_ISSEARCHCENTER: (state, isCenter) => {
    state.isCenter = isCenter
  },
  // logo以及商城名称
  SET_LOGOINFO: (state, {logoUrl, logoLink}) => {
    state.logoUrl = logoUrl
    state.logoLink = logoLink
    // state.mallName = mallName
  },
  // 个人信息展示模版
  SET_USERINFO_TEMPLATE: (state, userInfoLocation) => {
    state.userInfoLocation = userInfoLocation
  },
  // 设置应用分类
  SET_APPLICATION_CLASSIFYLIST: (state, applicationClassifyList) => {
    state.applicationClassifyList = applicationClassifyList
  },
  // 设置全部菜单
  SET_ALLMENU: (state, allMenu) => {
    state.allMenu = allMenu
  },
  SET_PAGEFRAME: (state, pageFrame) => {
    state.pageFrame = pageFrame
  },
  SET_PAGEFRAME_STATUS: (state, status) => {
    state.pageFrameStatus = status
  },
  SET_NONCATALOG_NAME: (state, nonCatalogName) => {
    state.nonCatalogName = nonCatalogName
  }
}
export default mutation
